import React from "react";
import PropTypes from "prop-types";
import Flatpickr from "react-flatpickr";
import { InputGroup, InputGroupText } from "reactstrap";
import { FieldShell, fieldBaseProps } from "./Fields";

/**
 * 日期區間選擇（design system primitive，模板 Forms > Advanced 的 flatpickr）。
 *
 * 日曆樣式走 scss 鏈(app.scss 先載 flatpickr 基底再載 _datepicker.scss 覆蓋),
 * 這裡不 import 廠商 css —— jest 不轉 node_modules 的 css。
 *
 * 報表期間、合約到期查詢、各頁查詢條件都用這個,值格式全站一致:
 * `["YYYY-MM-DD", "YYYY-MM-DD"]`(只挑了起日就只有一個元素;清空就是 `[]`)。
 *
 *   <DateRangeField label="報表期間" value={range} onChange={setRange} />
 */

// flatpickr 回傳 Date[],轉成全站一致的 YYYY-MM-DD 字串(用本地時區,不要 toISOString)
const toYmd = (d) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const DateRangeField = ({
  label, name, value = [], onChange, required, error, help, disabled,
  placeholder = "選擇起訖日期", separator = " 到 ",
  ...rest
}) => {
  const has = value && value.length > 0;
  return (
    <FieldShell label={label} required={required} error={error} help={help}>
      <InputGroup>
        <Flatpickr
          className={`form-control${error ? " is-invalid" : ""}`}
          id={name}
          aria-label={label}
          placeholder={placeholder}
          disabled={disabled}
          value={value}
          options={{ mode: "range", dateFormat: "Y-m-d", locale: { rangeSeparator: separator } }}
          onChange={(dates) => onChange && onChange(dates.map(toYmd))}
          {...rest}
        />
        {has && !disabled ? (
          // 真的 <button>:Enter 與空白鍵都能按,不用自己補鍵盤事件
          <button
            type="button"
            className="input-group-text"
            aria-label="清除期間"
            onClick={() => onChange && onChange([])}
          >
            <i className="mdi mdi-close" />
          </button>
        ) : (
          <InputGroupText><i className="bx bx-calendar-event" /></InputGroupText>
        )}
      </InputGroup>
    </FieldShell>
  );
};
DateRangeField.propTypes = {
  ...fieldBaseProps,
  value: PropTypes.arrayOf(PropTypes.string),
  separator: PropTypes.string,
};

export default DateRangeField;
